import { useLocaleData, useT } from "../../i18n/useT";
import React from "react";

const Certificates = () => {
  const t = useT();
  const items = useLocaleData("sections.certificates.items") || [];
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="certificates">
      <h1 className="text-uppercase mb-4">
        {t("sections.certificates.title")}
      </h1>
      {items.map((cert, idx) => (
        <div className="row my-2" key={idx}>
          <div className="col-xs-12 col-md-8">
            <h4 className="text-secondary">{cert.name}</h4>
            {cert.level ? (
              <h5 className="text-secondary">{cert.level}</h5>
            ) : null}
            {cert.description ? (
              <p className="text-secondary">{cert.description}</p>
            ) : null}
          </div>
          <div className="col-xs-12 col-md-4">
            <p className="text-primary">{cert.date}</p>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Certificates;
